import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { printf, toFail } from "../../fable_modules/fable-library.3.7.20/String.js";

export class Filter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Active", "ActiveWithEndDate", "Cancelled", "Pending", "NoContracts"];
    }
}

export function Filter$reflection() {
    return union_type("Containers.Search.Model.Filter", [], Filter, () => [[], [], [], [], []]);
}

export function Filter_get_toString() {
    return (_arg) => ((_arg.tag === 2) ? "Cancelled" : ((_arg.tag === 3) ? "Pending" : ((_arg.tag === 1) ? "ActiveWithEndDate" : ((_arg.tag === 4) ? "NoContracts" : "Active"))));
}

export function Filter_get_ofString() {
    return (_arg) => ((_arg === Filter_get_toString()(new Filter(0))) ? (new Filter(0)) : ((_arg === Filter_get_toString()(new Filter(2))) ? (new Filter(2)) : ((_arg === Filter_get_toString()(new Filter(3))) ? (new Filter(3)) : ((_arg === Filter_get_toString()(new Filter(1))) ? (new Filter(1)) : ((_arg === Filter_get_toString()(new Filter(4))) ? (new Filter(4)) : toFail(printf("Could not parse string \u0027%s\u0027 to Filter."))(_arg))))));
}

export function Filter_toTranslation_11D407F6(getTranslation) {
    return (_arg) => ((_arg.tag === 1) ? getTranslation("Common.ActiveWithEndDate") : ((_arg.tag === 2) ? getTranslation("CustomerContract.Search.Cancelled") : ((_arg.tag === 3) ? getTranslation("CustomerContract.Search.Pending") : ((_arg.tag === 4) ? getTranslation("CustomerContract.Search.NoContracts") : getTranslation("CustomerContract.Search.Active")))));
}

